import React from "react";
import { Container } from "react-bootstrap";
import "./ScamAlertBanner.css";
import { Link } from "react-router-dom";

const ScamAlertBanner = () => {
  return (
    <div className="scam-alert-banner-parent">
      <Container className="d-flex align-items-center justify-content-center py-2">
        <div className="banner-content-wrapper d-flex align-items-center gap-2">
          {/* Warning Triangle Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="warning-icon"
            viewBox="0 0 24 24"
          >
            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>

          {/* Strong/Bold Tagline */}
          <strong className="alert-title">Beware of Scammers</strong>

          {/* Main Informational Text */}
          <span className="alert-text">
            We don't charge money for job offers
          </span>

          {/* Action Link Button */}
          <Link
            to="/safe-job-search"
            className="know-more-link d-inline-flex align-items-center gap-1"
          >
            Know More
            <span className="arrow-icon">→</span>
          </Link>
        </div>
      </Container>
    </div>
  );
};

export default ScamAlertBanner;
